import { render, staticRenderFns } from "./TicketStatsModal.vue?vue&type=template&id=dac0e4d6&scoped=true&"
import script from "./TicketStatsModal.vue?vue&type=script&lang=js&"
export * from "./TicketStatsModal.vue?vue&type=script&lang=js&"
import style0 from "./TicketStatsModal.vue?vue&type=style&index=0&id=dac0e4d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac0e4d6",
  null
  
)

export default component.exports